import { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '../../../components/Button';
import EnvironmentForm from './EnvironmentForm';
import { modes } from './Environments';

const EnvironmentFormDialog = ({
  open,
  onClose,
  title,
  onExitAddMode,
  selectedEnvironment,
  mode,
  editEnvironmentId,
  onSuccess,
}) => {
  const formSubmitRef = useRef(null);
  const onCancel = () => {
    onClose();
  };

  const handleSave = () => {
    if (formSubmitRef.current) {
      formSubmitRef.current();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 750,
          maxWidth: 880,
        },
      }}>
      <DialogTitle sx={{ pb: 1 }}>{title}</DialogTitle>
      <DialogContent sx={{ pt: 1, px: 2, pb: 1 }}>
        <EnvironmentForm
          formSubmitRef={formSubmitRef}
          onExitAddMode={onExitAddMode}
          onClose={onCancel}
          isEditMode={mode === modes.edit}
          name={selectedEnvironment?.name}
          configManagerSupportId={selectedEnvironment?.configManagerSupportId}
          description={selectedEnvironment?.description}
          location={selectedEnvironment?.location}
          editEnvironmentId={editEnvironmentId}
          onSuccess={onSuccess}
        />
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2, pt: 1 }}>
        <Button
          variant="text"
          onClick={onCancel}
          styles={{
            color: '#B5B5B5',
            textTransform: 'capitalize',
          }}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={handleSave}
          styles={{
            textTransform: 'capitalize',
          }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnvironmentFormDialog;
